import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ExamConfigBody from "../ExamConfigBody/ExamConfigBody";
import ExamConfigDetails from "../ExamConfigDetails/ExamConfigDetails";
import ExamConfigFilter from "../ExamConfigFilter/ExamConfigFilter";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewExamConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      search: {
        session: new Date().getFullYear().toString(),
        className: "",
        examType: "",
        facultyName: "",
        groupName: "",
        sectionName: "",
        startDate: "",
      },
      isEmpty: false,
      detailStatus: false,
      detailData: [],
      column: [
        { name: "S.N." },
        { name: "Session" },
        { name: "Exam Name" },
        { name: "Class" },
        { name: "Faculty" },
        { name: "Group" },
        { name: "Section" },
        { name: "Exam Start Date" },
        { name: "Exam End Date" },
        { name: "Actions" },
      ],
      examConfig: [],
    };
  }

  componentDidMount() {
    this.getExamConfig();
  }

  getExamConfig = async () => {
    try {
      const response = await Axios.get(`${url}/api/exams`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.exams.length !== 0) {
        this.setState({
          examConfig: response.data.exams,
          isEmpty: false,
        });
      } else {
        this.setState({
          examConfig: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getExamConfig();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.examConfig.filter((exam) => {
      return (
        exam.session
          .toLowerCase()
          .indexOf(this.state.search.session.toLowerCase()) !== -1 &&
        exam.examType
          .toLowerCase()
          .indexOf(this.state.search.examType.toLowerCase()) !== -1 &&
        exam.className
          .toLowerCase()
          .indexOf(this.state.search.className.toLowerCase()) !== -1 &&
        exam.startDate.indexOf(this.state.search.startDate) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Exam Configuration"
            refreshUrl={this.props.match.url}
            addUrl={"/administration/examconfig/add"}
            urlTitle="Add Exam Config"
          />
          {this.state.examConfig.length !== 0 && (
            <ExamConfigFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}

          {this.state.examConfig.length !== 0 ? (
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={12}
                md={this.state.detailStatus ? 8 : 12}
                xl={this.state.detailStatus ? 8 : 12}
                lg={this.state.detailStatus ? 8 : 12}
              >
                <Paper>
                  <TableContainer>
                    <Table>
                      <CustomTableHead column={this.state.column} />

                      <TableBody>
                        {(rowsPerPage > 0
                          ? filtered.slice(
                              rowsPerPage * page,
                              rowsPerPage * page + rowsPerPage
                            )
                          : filtered
                        ).map((exam, index) => (
                          <ExamConfigBody
                            data={exam}
                            key={index}
                            index={index}
                            handleDetailStatus={this.handleDetailStatus}
                            getExamConfig={this.getExamConfig}
                          />
                        ))}
                      </TableBody>

                      <CustomTableFooter
                        count={filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handlePage}
                        onChangeRowsPerPage={this.handleRowsPerPage}
                      />
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
              {this.state.detailStatus && (
                <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
                  <Paper>
                    <ExamConfigDetails
                      detailData={this.state.detailData}
                      handleCancelDetail={this.handleCancelDetail}
                    />
                  </Paper>
                </Grid>
              )}
            </Grid>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewExamConfig)));
